/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Price_UnitInputs */

const cs_form_price_unit = /** @type {(inputs: Form_Price_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jednotka ceny`)
};

const en_form_price_unit = /** @type {(inputs: Form_Price_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price unit`)
};

/**
* | output |
* | --- |
* | "Price unit" |
*
* @param {Form_Price_UnitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_price_unit = /** @type {((inputs?: Form_Price_UnitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Price_UnitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_price_unit(inputs)
	return cs_form_price_unit(inputs)
});